(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/serversiderouter.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/serversiderouter.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.app.ServerSideHelper.ServerSideRouterDecorator = {
    decorate: function decorate(router) {
      var decorated = _.extend(router, {
        isRenderedServerSide: true,
        $documentBody: $(document.body),
        setDefaultRegion: function setDefaultRegion(region) {
          this.defaultRegion = region;
        },
        showView: function showView(view, options, region) {
          var viewToShow;

          if (!region && this.defaultRegion) {
            region = this.defaultRegion;
          } else {
            return;
          }

          if (this.isRenderedServerSide) {
            if (!_.isObject(region.el)) {
              region._ensureElement();
            }

            options = options || {};
            viewToShow = new view(_.extend({
              el: $('.js-server-rendered-root'),
              preRendered: true
            }, options));
            svs.app.ServerSideHelper.utils.initView(viewToShow, region);

            if (viewToShow._firstTimeServerSideRender === undefined) {
              viewToShow.triggerMethod('attach');
            } else {
              viewToShow.triggerMethod('serverside:initialized');
            }

            region.triggerMethod('show');
          } else {
            this.$documentBody.prop('scrollTop', 0);
            region.show(new view(options));
          }
        }
      });

      decorated._initialize = decorated.initialize;

      decorated.initialize = function () {
        this.once('route', function () {
          this.isRenderedServerSide = false;
        }, this);

        if (decorated._initialize) {
          decorated._initialize.apply(this, arguments);
        }
      };

      return Backbone.Router.extend(decorated);
    }
  };
})(Backbone, _, svs);
 })(window);